// import library
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from"moment";
// import components
import Layout from "../../layouts/Layout";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import Pagination from "../../components/Common/Table/Pagination";
import LoaderIcon from "../../components/Common/Icon/Loader";
import FilterFormLayout from "../../components/Common/Table/FilterFormLayout";
import MonthDropDown from "../../components/Common/InputField/MonthDropDown";
import DateInputField from "../../components/Common/InputField/DateInputField";
// import files
import { env } from "../../env";
import SearchBar from "../../components/Common/Table/SearchBar";
import SortData from "../../components/Common/Table/SortData";
import MobilePagination from "../../components/Common/Table/MobilePagination";
import { logEvent } from "../../analytics";

const OrderHistoryIndex = () => {
    // variables
    const { t } = useTranslation();
    const dropdownRef = useRef(null);
    const dropdownRef1 = useRef(null);
    const [isLoader, setIsLoader] = useState(true);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [orders, setOrders] = useState({
        "total_record": 0,
        "totalpages": 0,
        "list": []
    });
    const [rowCurrentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState('orderdate');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortName, setSortName] = useState("");
    const [showSort, setShowSort] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showAction, setShowAction] = useState(false);
    const [actionKey, setActionKey] = useState(0);
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const [filterInputs, setFilterInputs] = useState({
        month: "",
        createmonth: "0",
        date: "",
        status_ids: [],
    });
    const [statusList, setStatusList] = useState([]);
    const [sortTypesList, setSortTypesList] = useState([
        {
            "name" : "customer name - top to bottom",
            "field" : "customername",
            "type" : "asc"
        },
        {
            "name" : "customer name - bottom to top",
            "field" : "customername",
            "type" : "desc"
        },
        {
            "name" : "order id - top to bottom",
            "field" : "orderid",
            "type" : "asc"
        },
        {
            "name" : "order id - bottom to top",
            "field" : "orderid",
            "type" : "desc"
        },
        {
            "name" : "ordered date - top to bottom",
            "field" : "orderdate",
            "type" : "asc"
        },
        {
            "name" : "ordered date - bottom to top",
            "field" : "orderdate",
            "type" : "desc"
        },
        {
            "name" : "total quantity - top to bottom",
            "field" : "totalqty",
            "type" : "asc"
        },
        {
            "name" : "total quantity - bottom to top",
            "field" : "totalqty",
            "type" : "desc"
        },
        {
            "name" : "total order - top to bottom",
            "field" : "finalamount",
            "type" : "asc"
        },
        {
            "name" : "total order - bottom to top",
            "field" : "finalamount",
            "type" : "desc"
        },
        {
            "name" : "status - top to bottom",
            "field" : "order_status",
            "type" : "asc"
        },
        {
            "name" : "status - bottom to top",
            "field" : "order_status",
            "type" : "desc"
        },
    ]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowSort(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
                setShowFilter(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // functions
    useEffect(() => {
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        getOrderStatusListApi();
    }, []);

    const getOrderHistoryListApi = async(data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "application/json",
            "Content-Type" : "application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+"/api/OfflineSync/GetOrderListSearch", data, {headers})
        .then((response) => {
            if(!response.data.success) {
                setOrders(response.data);
            }
            setIsLoader(false);
            setIsTableLoader(false);        
        }).catch((error) => {
            console.log(error);
        });
    };
    const getOrderStatusListApi = async() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "application/json",
            "Content-Type" : "application/json",
            "Authorization" : `Bearer ${token}`
        };
        await axios.get(baseUrl+"/api/OfflineSync/GetOrderStatusList", {headers})
        .then((response) => {
            if(response.data) {
                setStatusList(response.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };
    const handleCurrentPage = (page) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setCurrentPage(page);
        const requestData = {
            page_num : page,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        logEvent('order_history_list_page', 'order_list', 'pagination', page);
    };
    const handlePerPage = (row) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setRowsPerPage(row);
        const requestData = {
            page_num : 1,
            page_size : row,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        logEvent('order_history_list_page', 'order_list', 'pagination-per-page', row);
    };
    const handleShowSort = (e) => {
        e.preventDefault();
        setShowSort(!showSort); 
        setShowFilter(false);
    };
    const handleShowFilter = (e) => {
        setShowFilter(!showFilter); 
        setShowSort(false); 
    };
    const handleSearchDataFromChild = (data) => {
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setSearchTerm(data);
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : data,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        logEvent('order_history_list_page', 'order_list', 'search', data);
    };
    const handleSortDataFromChild = (data) => {
        setSortBy(data.field);
        setSortOrder(data.type);
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : data.field,
            sort_order : data.type,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        logEvent('order_history_list_page', 'order_list', 'sort', data);
    };
    const handleSortTypeDataFromChild = (e, data) => {
        e.preventDefault();
        setSortBy(data.field);
        setSortOrder(data.type);
        setSortName(data.name);
        setShowSort(!showSort); 
        const requestData = {
            page_num : rowCurrentPage,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : data.field,
            sort_order : data.type,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        logEvent('order_history_list_page', 'order_list', 'sort', data);
    };
    const openAction = (e, index) => {
        e.preventDefault();
        if(actionKey === index) {
            setShowAction(!showAction);
        } else {
            setShowAction(true);
        }
        setActionKey(index);
    };
    const handleDateDataFromChild = (e) => {
        setFilterInputs({
            ...filterInputs,
            'date' : e.target.value
        });
    };
    const handleMonthDataFromChild = (data) => {
        if(data) {
            setFilterInputs({
                ...filterInputs,
                'month' : data.name,
                'createmonth' : data.id
            });
        } else {
            setFilterInputs({
                ...filterInputs,
                'month' : "",
                'createmonth' : "0"
            });
        }
    };
    const handleStatusCheckboxChange = (id) => {
        const updated = filterInputs.status_ids.includes(id)
            ? filterInputs.status_ids.filter(s => s !== id)
            : [...filterInputs.status_ids, id];
        setFilterInputs({ ...filterInputs, status_ids: updated });
    };
    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: filterInputs.createmonth,
            status_ids: filterInputs.status_ids,
            order_date: filterInputs.date
        }
        getOrderHistoryListApi(requestData);
        setShowFilter(!showFilter);
        logEvent('order_history_list_page', 'order_list', 'filter', requestData);
    };
    const clearData = (e) => {
        e.preventDefault();
        setIsTableLoader(true);
        setOrders({
            "total_record": 0,
            "totalpages": 0,
            "list": []
        });
        setFilterInputs({
            ...filterInputs,
            'month' : "",
            'createmonth' : "0",
            'date': "",
            'status_ids': [],
        });
        const requestData = {
            page_num : 1,
            page_size : rowsPerPage,
            search_term : searchTerm,
            sort_by : sortBy,
            sort_order : sortOrder,
            month_info: "0",
            status_ids: [],
            order_date: ""
        }
        getOrderHistoryListApi(requestData);
        setShowFilter(!showFilter);
        logEvent('order_history_list_page', 'order_list', 'filter', 'clear-filter');
    };
    const handleLog = (id) => {
        logEvent('order_history_list_page', 'order_list', 'redirect_to_order_detail', id);
    };

    return  (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="sm:text-2xl font-semibold capitalize">{ t('order history') }</h1>
                        <p className="text-light-400 text-xs sm:text-sm capitalize">{ t('orders') } / { t('order history') }</p>
                    </div>
                </div>
                { isLoader
                    ? 
                        <LoaderIcon />
                    :
                        <div className="p-2 sm:p-4 bg-white border border-white rounded-lg space-y-2 sm:space-y-4 shadow-around">
                            {/* search bar and filter */}
                            <div className="sm:flex sm:justify-between sm:items-center sm:space-x-2 space-y-2 sm:space-y-0">
                                <SearchBar placeholder={ t('search by customer name')} term={searchTerm} setSearchDataFromChild={handleSearchDataFromChild}/>
                                <div className="flex items-center justify-end space-x-2">
                                    <div ref={dropdownRef} className="relative"> 
                                        <div className="sm:hidden flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3 sm:px-4" onClick={(e) => handleShowSort(e)}>
                                            <img className="w-6 h-6" src="../../../assets/icons/table/sort.svg" alt="sort" />
                                        </div>
                                        {
                                            showSort
                                            ?
                                                <ul className="z-20 py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-56 text-left h-40 overflow-y-auto no-scrollbar">
                                                    {sortTypesList.map((value, index) => (
                                                        <li key={index} onClick={(e) => handleSortTypeDataFromChild((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                                                    ))}
                                                </ul>
                                            : null
                                        }
                                    </div>
                                    <div ref={dropdownRef1} className="relative">
                                        <div className="flex w-fit text-right items-center cursor-pointer bg-black-300 rounded-lg py-3 sm:py-2 px-4" onClick={(e) => handleShowFilter(e)}>
                                            <div>
                                                <img className="w-3.5 sm:w-4" src="../../assets/icons/table/filter.svg" alt="filter" />
                                            </div>
                                            <div className="hidden sm:block ml-2 text-blue-normal font-medium text-xl capitalize">{ t('filter')}</div>
                                        </div>
                                        {
                                            showFilter 
                                            ?
                                                <FilterFormLayout>
                                                    <form onSubmit={handleFilterSubmit}>
                                                        <div className="px-2 sm:px-4 space-y-2 sm:space-y-4">
                                                            <div>
                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('ordered date')}</label>
                                                                <div className="w-full py-2 px-4 bg-background-normal rounded-md mt-1 text-gray-600 ">
                                                                    <input
                                                                        type="date"
                                                                        placeholder="DD-MM-YYYY"
                                                                        value={filterInputs.date}
                                                                        onChange={handleDateDataFromChild}
                                                                        className="focus:outline-none bg-background-normal w-full"
                                                                    />
                                                                </div>
                                                            </div>
                                                            <MonthDropDown monthValue={filterInputs.month} sendMonthDataFromChild={handleMonthDataFromChild} />
                                                            <div>
                                                                <label className="font-medium capitalize text-sm sm:text-base">{ t('status')}</label>
                                                                <div className="mt-1 max-h-40 overflow-y-auto no-scrollbar">
                                                                    {statusList.map((status) => (
                                                                        <div key={status.id} className="flex items-center my-3">
                                                                            <label className="relative flex items-center cursor-pointer">
                                                                                <input type="checkbox" value={status.id} checked={filterInputs.status_ids.includes(status.id)} onChange={() => handleStatusCheckboxChange(status.id)} className="before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded border border-gray-dark transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-white before:opacity-0 before:transition-opacity checked:border-blue-normal checked:bg-blue-normal checked:before:bg-blue-normal" />
                                                                                <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                                                                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
                                                                                    </svg>
                                                                                </span>
                                                                            </label>
                                                                            <div className="font-normal text-sm sm:text-base ml-2 text-light-400 capitalize">{ t(status.title.toLowerCase())}</div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                            <div className="flex items-center justify-end my-2">
                                                                <div>
                                                                    <button onClick={(e) => clearData(e)} className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 bg-white text-blue-normal border border-blue-normal rounded-lg capitalize">{ t('clear')}</button>
                                                                </div>
                                                                <div className="ml-4">
                                                                    <button type="submit" className="text-center px-2 lg:px-4 text-sm font-medium lg:text-base py-2 text-white bg-blue-normal border border-blue-normal rounded-lg capitalize">{ t('apply')}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </FilterFormLayout>
                                            : null
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* table */}
                            <div className="sm:block hidden relative overflow-x-auto shadow-md rounded-lg">
                                <table className="w-full text-xs">
                                    <thead className="text-gray-normal bg-background-normal">
                                        <tr>
                                            <th scope="col" className="font-normal p-4 w-1/5">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('customer name') }
                                                    </div>
                                                    <SortData fieldName={'customername'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('order number') }
                                                    </div>
                                                    <SortData fieldName={'orderid'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('ordered date') }
                                                    </div>
                                                    <SortData fieldName={'orderdate'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('quantity') }
                                                    </div>
                                                    <SortData fieldName={'totalqty'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4">
                                                <div className="flex">
                                                    <div className="mr-2 uppercase">
                                                        { t('status') }
                                                    </div>
                                                    <SortData fieldName={'order_Status'} sortNameData={sortBy} sortTypeData={sortOrder} setSortDataFromChild={handleSortDataFromChild} />
                                                </div>
                                            </th>
                                            <th scope="col" className="font-normal p-4 uppercase text-left">
                                                { t('actions') }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    { orders.list.length > 0 ?
                                        (orders.list).map((row, index) => (
                                            <tr key={'order'+row.orderid} className="bg-white border-b hover:bg-gray-50 ">
                                                <td className="p-4 text-light-400">
                                                    {row.customername ? row.customername : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.orderid}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.orderdate ? moment(row.orderdate).format("DD/MM/YYYY") : 'NA'}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {formatter.format(row.totalqty)}
                                                </td>
                                                <td className="p-4 text-light-400">
                                                    {row.order_Status ?
                                                        <div
                                                            style={{ color: row.statuscolor, backgroundColor: row.statuscolor + '20' }}
                                                            className="px-4 py-2 border rounded text-center font-medium capitalize"
                                                        >
                                                            { t(row.order_Status.toLowerCase())}
                                                        </div>
                                                        : 'NA'
                                                    }
                                                </td>
                                                <td className="p-4">
                                                    <div className="flex flex-col items-center relative">
                                                        <img className={showAction && actionKey === (row.orderid) ? "bg-background-normal p-3 rounded-full" : null + " cursor-pointer"} src="../../assets/icons/table/vertical-dot.svg" onClick={(e) => openAction(e, row.orderid)} alt="dot" />
                                                        {
                                                            showAction && actionKey === (row.orderid)
                                                            ? 
                                                                <div className="absolute w-max right-[3.2rem] top-1 bg-white border border-white shadow-md rounded">
                                                                    <ul>
                                                                        <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded" onClick={handleLog(row.orderid)}>
                                                                            <NavLink to={`/order/history/${row.orderid}`} className="capitalize flex">
                                                                                { t('view') }
                                                                            </NavLink>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            : null
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        )) 
                                            : null
                                        }
                                    </tbody>
                                </table>
                                {/* pagination */}
                                { isTableLoader
                                    ?
                                        <TableLoaderIcon />
                                    : (
                                        orders.list.length > 0 
                                        ?
                                            <Pagination
                                                currentPage={rowCurrentPage}
                                                totalCount={orders.total_record}
                                                pageSize={rowsPerPage}
                                                perPageCount={orders.list.length}
                                                onPageChange={page => handleCurrentPage(page)}
                                                onPageSizeChange={row => handlePerPage(row)}
                                            />
                                        : 
                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                    { t('no data available')}
                                            </div>
                                    )
                                }
                            </div>
                            <div className="sm:hidden block bg-white border border-white rounded-lg space-y-3">
                                {(orders.list.length > 0) ?
                                    <div className="space-y-3 h-[25rem] overflow-y-auto no-scrollbar">
                                        { orders.list.map((row, index) => (
                                            <div key={'order'+row.orderid} className=" border border-action-hover bg-action-hover rounded-[10px] p-2 space-y-2">
                                                <div className="space-y-1">
                                                    <div>
                                                        <div className="flex justify-between items-center">
                                                            <div className="font-medium text-base">{row.customername ? row.customername : 'NA'}</div>
                                                            <div className="flex flex-col items-center relative">
                                                                <img className="cursor-pointer" src="../../assets/icons/table/vertical-dot.svg" onClick={(e) => openAction(e, row.orderid)} alt="dot" />
                                                                {
                                                                    showAction && actionKey === (row.orderid)
                                                                    ? 
                                                                        <div className="absolute w-max right-[1.2rem] top-1 bg-white border border-white shadow-md rounded">
                                                                            <ul>
                                                                                <li className="hover:bg-action-hover px-2 py-1 text-xs hover:rounded" onClick={handleLog(row.orderid)}>
                                                                                    <NavLink to={`/order/history/${row.orderid}`} className="capitalize flex">
                                                                                        { t('view') }
                                                                                    </NavLink>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    : null
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="text-light-400 text-xs">
                                                            <span className="capitalize">{ t('order id')} : </span><span className="font-medium">{row.orderid}</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex text-sm items-center justify-between">
                                                        <div className="flex text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('quantity')}:</h1>
                                                            <div className="font-bold ml-2">{formatter.format(row.totalqty)}</div>
                                                        </div>
                                                        <div className="flex text-sm text-light-400 items-center">
                                                            <h1 className="capitalize font-medium">{ t('status')}:</h1>
                                                            <div className="font-bold ml-2">
                                                                {row.order_Status ?
                                                                    <div
                                                                        style={{ color: row.statuscolor, backgroundColor: row.statuscolor + '20' }}
                                                                        className="px-4 py-2 border rounded text-center font-medium capitalize"
                                                                    >
                                                                        { t(row.order_Status.toLowerCase())}
                                                                    </div>
                                                                    : 'NA'
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex text-sm text-light-400 items-center">
                                                        <h1 className="capitalize font-medium">{ t('ordered date')}:</h1>
                                                        <div className="font-bold ml-2">{row.orderdate ? moment(row.orderdate).format("DD/MM/YYYY") : 'NA'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    : null
                                }
                                { isTableLoader
                                    ?
                                        <TableLoaderIcon />
                                    : (
                                        orders.list.length > 0 
                                        ?
                                            <MobilePagination
                                                currentPage={rowCurrentPage}
                                                totalCount={orders.total_record}
                                                pageSize={rowsPerPage}
                                                perPageCount={orders.list.length}
                                                onPageChange={page => handleCurrentPage(page)}
                                                onPageSizeChange={row => handlePerPage(row)}
                                            />
                                        : 
                                            <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                                { t('no data available')}
                                            </div>
                                    )
                                }
                            </div>
                        </div>
                }
            </div>
        </Layout>
    )
}

export default OrderHistoryIndex;